<template>
  <div class="personalCenter">
    <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="personalCenterCon clearfix">
      <div class="personalCenterLeft pull-left">
        <ul class="nav nav-pills nav-stacked" role="tablist">
          <li role="presentation" class="active">
            <a href="#basic" aria-controls="basic" role="tab" data-toggle="tab">基本信息<span class="collapseArrow"></span></a>
          </li>
          <li role="presentation">
            <a href="#binding" aria-controls="binding" role="tab" data-toggle="tab">账号绑定<span class="collapseArrow"></span></a>
          </li>
          <li role="presentation">
            <a href="#changePassword" aria-controls="changePassword" role="tab" data-toggle="tab">修改密码<span class="collapseArrow"></span></a>
          </li>
          <li>
            <a @click="linkUrl" style="cursor: pointer;">我的订单<span class="collapseArrow"></span></a>
          </li>
        </ul>
      </div>
      <div class="personalCenterRight">
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="basic">
            <div class="personalRightTit">
              <h3>基本信息</h3>
            </div>
            <div class="personalRightCon">
              <el-form :model="updateForm" label-width="84px"  :rules="rules" ref="personForm" method="post" class="form-horizontal" >

                <div class="form-group userImage">
                  <label class="control-label pull-left">头像</label>
                  <div class="control-con">
                    <div class="imageBox">
                      <img :src="updateForm.fileUrl" alt="">
                      <input type="file" id="exampleInputFile" name="upfile" @change="tirggerFile($event)" multiple>
                    </div>
                    <p>仅支持JPG、GIF、PNG、JPEG、BMP格式，文件小于2M</p>
                  </div>
                </div>
                  <el-form-item prop="trueName"  label="姓名" class="personalName">
                    <el-input type="text"  :maxlength="40" v-model="updateForm.trueName" name="trueName" placeholder="请输入姓名" ref="trueName"/>
                  </el-form-item>
                  <el-form-item prop="sex"  label="性别">
                    <el-radio v-model="updateForm.sex" label="0">男</el-radio>
                    <el-radio v-model="updateForm.sex" label="1">女</el-radio>
                  </el-form-item>
                <div class="form-group">
                  <label class="control-label pull-left">手机号码</label>
                  <div class="control-con clearfix">
                    <input type="text" :maxlength="30" class="form-control" name="mobile" placeholder="请输入手机号码" v-model="updateForm.mobile" style="float: left;margin-right: 10px;" ref="mobile" @change="validMobile" @keyup="isOverseasShow"/>
                    <el-checkbox v-show="isOverseas" v-model="overseasMobile" @change="validMobile" style="height: 32px;line-height: 32px;margin: 0px;">境外手机号</el-checkbox>
                    <span v-show="invalidMobile" style="color: #F56C6C;font-size: 12px;line-height: 1;padding-top: 1px;position: absolute;top: 100%;left: 0;">{{invalidText}}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label pull-left">联系电话</label>
                  <div class="control-con">
                    <input type="text" :maxlength="20" class="form-control" name="tel" placeholder="请输入联系电话" v-model="updateForm.tel" ref="tel"/>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label pull-left">传真</label>
                  <div class="control-con">
                    <input type="text" :maxlength="20" class="form-control" placeholder="请输入传真号码" v-model="updateForm.fax" ref="fax"/>
                  </div>
                </div>

                <el-form-item  label="生日">
                  <el-date-picker  type="date" :placeholder="placeholder" v-model="updateForm.birth"></el-date-picker>
                </el-form-item>
                <div class="form-group">
                  <label class="control-label pull-left">身份证</label>
                  <div class="control-con">
                    <input type="text" :maxlength="20" class="form-control" placeholder="请输入身份证号码" v-model="updateForm.identityNum" ref="identityNum"/>
                  </div>
                </div>


                <div class="form-group">
                  <div class="control-con">
                    <button type="button" class="btn btn-info" id="validateBtn" @click="submitAccount()">保存</button>
                  </div>
                </div>
              </el-form>

            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="binding">
            <div class="personalRightTit">
              <h3>账号绑定</h3>
              <p>所有绑定邮箱、手机号码都可用于登录，主邮箱和主手机账号可收取通知</p>
            </div>
            <div class="personalRightCon">
              <form id="bindingForm" method="post" class="form-horizontal">

                <div class="form-group">
                  <label class="control-label pull-left">邮箱</label>
                  <div class="control-con">
                    <input type="email" class="form-control" name="email" disabled v-model="email"/>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="changePassword">
            <div class="personalRightTit">
              <h3>修改密码</h3>
            </div>
            <div class="personalRightCon">
              <el-form :model="operateForm" label-width="84px"  :rules="operateRules" ref="passwordForm" method="post" class="form-horizontal" >


                  <el-form-item prop="currentPasssword"  label="当前密码">
                    <el-input type="password" v-model="operateForm.currentPasssword" name="currentPasssword" placeholder="请输入当前密码" :minlength="6" :maxlength="20"/>
                  </el-form-item>
                  <el-form-item prop="newPasssword"  label="新密码">
                    <el-input type="password" v-model="operateForm.newPasssword" name="newPasssword" placeholder="请输入6-20位的登录密码" ref="newPasssword" :minlength="6" :maxlength="20"/>
                  </el-form-item>
                  <el-form-item prop="confirmPasssword"  label="确认密码">
                    <el-input type="password" v-model="operateForm.confirmPasssword" name="confirmPasssword" placeholder="请输入6-20位的登录密码" :minlength="6" :maxlength="20"/>
                  </el-form-item>
                <div class="form-group">
                  <div class="control-con">
                    <button type="button" class="btn btn-info" id="valipasswordBtn" @click="submitPassword()">保存</button>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'

  export default {
    props: [],
    data () {
      var checkPassword = (rule, value, callback) => {
        if (value!=this.$refs.newPasssword.value) {
          return callback(new Error('两次密码不一致'));
        }else{
          return callback();
        }

      };
      var checkPasswordExt = (rule, value, callback) => {
        if (value.indexOf(" ")!=-1) {
          return callback(new Error('密码格式不正确，请输入6-20位的字母、数字或符号'));
        }else{
          return callback();
        }
      };
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(value)) {
          return callback(new Error('请输入11位有效手机号码'));
        }else{
          return callback();
        }
      };
      var checkIdentityNum = (rule, value, callback) => {
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(value)) {
          return callback(new Error('请输入有效的身份证号码'));
        }else{
          return callback();
        }
      };
      return {
        placeholder:'',
        email:'',
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        footerColumnInfos: [],
        bannerInfo: {title: '个人中心',content: "Personal Center"},
        webConfigInfo: {},
        userInfo:{},
        sexData:[{value:'0',name:'男',isCheck:false},{value:'1',name:'女',isCheck:false}],
        updateForm:{
          trueName:'',
          birth:'',
          upfile:{},
          complaintsAttachmentKey:'',
          complaintsAttachmentName:'',
          fileUrl:'',
          sex:'',
          mobile:'',
          tel:'',
          fax:'',
          identityNum:''
        },
        rules: {
          trueName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          mobile: [
             { validator: checkMobile, trigger: 'blur' }
          ],
          identityNum: [
             { validator: checkIdentityNum, trigger: 'blur' }
          ],
        },
        operateForm:{
          currentPasssword:'',
          newPasssword:'',
          confirmPasssword:''
        },
        operateRules:{
          currentPasssword: [
            { required: true, message: '请输入当前密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ],
          newPasssword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ],
          confirmPasssword: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' },
            { validator: checkPassword, trigger: 'blur' },
            { validator: checkPasswordExt, trigger: 'blur' }
          ]
        },
        justSex:'',
        showFlag:false,
        selectRadio:'',
        isOverseas:false,
        overseasMobile:false,
        invalidMobile:false,
        invalidText:'请输入11位有效手机号码',
        orderLink:''
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    computed: mapState([
      'KP'
    ]),
    created () {
      if(this.getToken('isLogin') != 100){
        this.$router.push("/login")
        return false
      }

      if(this.getToken('isLogin') == 100){
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        this.email = this.userInfo.email;
        // if(Object.keys(this.userInfo.faviconFileDto.fileUrl).length == 0){
        //   this.updateForm.fileUrl = 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/userImage.png';
        // }else{
        //   this.updateForm.fileUrl = this.userInfo.faviconFileDto.fileUrl;
        // }
        // this.updateForm.trueName = this.userInfo.trueName;
        // this.updateForm.birth = this.transferDate(this.userInfo.birth);
        // this.updateForm.sex = this.userInfo.sex;
        // this.updateForm.mobile = this.userInfo.mobile;
        // this.updateForm.tel = this.userInfo.tel;
        // this.updateForm.fax = this.userInfo.fax;
        // this.updateForm.identityNum = this.userInfo.identityNum;
        // this.updateForm.complaintsAttachmentKey = this.userInfo.logoFileKey;
        // this.updateForm.complaintsAttachmentName = this.userInfo.logoFileName;
      }

      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainPersonInfo?email='+this.userInfo.email, {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        // this.userInfo = this.data.userInfo;
        console.log(this.userInfo);
        if(Object.keys(this.userInfo.faviconFileDto.fileUrl).length == 0){
          this.updateForm.fileUrl = 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/userImage.png';
        }else{
          this.updateForm.fileUrl = this.userInfo.faviconFileDto.fileUrl;
        }
        this.updateForm.trueName = this.userInfo.trueName;
        if(Object.keys(this.userInfo.birth).length !=0){
          this.updateForm.birth = new Date(this.transferDate(this.userInfo.birth));
        }else{
          this.placeholder = '';
          this.updateForm.birth = null;
          this.placeholder = '请选择出生年月日';
        }
        this.updateForm.sex = this.userInfo.sex;
        this.updateForm.mobile = this.userInfo.mobile;
        if(this.updateForm.mobile==''){
          this.isOverseas = true;
        }
        this.updateForm.tel = this.userInfo.tel;
        this.updateForm.fax = this.userInfo.fax;
        this.updateForm.identityNum = this.userInfo.identityNum;
        this.updateForm.complaintsAttachmentKey = this.userInfo.logoFileKey;
        this.updateForm.complaintsAttachmentName = this.userInfo.logoFileName;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
      this.sexData.forEach(element => {
        if(element.value == this.userInfo.sex){
          element.isCheck = true;
          this.selectRadio = element.value;
        }
      })
      this.orderFn();
    },
    methods: {
      changeRadio(index){
        for (let i = 0; i < this.sexData.length; i++) {
          const element = this.sexData[i];
          if(i == index){
            this.justSex = element.value;
          }
        }
      },
      submitAccount(){
        this.$refs['personForm'].validate((valid) => {
          if (valid) {
            if(this.invalidMobile){
              return;
            }
            this.$axios.post('/onelink.mdata.main.api/user/updateMemberInformation', {
                id: this.userInfo.id,
                trueName:this.$refs.trueName.value,
                mobile: this.$refs.mobile.value,
                tel: this.$refs.tel.value,
                fax: this.$refs.fax.value,
                birth: this.updateForm.birth,
                sex:this.updateForm.sex,
                identityNum: this.$refs.identityNum.value,
                logoAttachmentName:this.updateForm.complaintsAttachmentName,
                logoAttachmentUrl:this.updateForm.complaintsAttachmentKey,
                email:this.userInfo.email
              }).then((res) => {
                this.data = res.data;
                let operateFlag = this.data.data.updateFlag;
                if(operateFlag){
                this.$message({
                     message: "保存成功!",
                     type: 'success'
                 });
                 let currentrUserInfo = this.data.data.userInfo;
                 this.userInfo = currentrUserInfo;
                 this.userInfo.trueName = currentrUserInfo.trueName;
                 this.userInfo.mobile = currentrUserInfo.mobile;
                 this.userInfo.tel = currentrUserInfo.tel;
                 this.userInfo.fax = currentrUserInfo.fax;
                 this.userInfo.sex = currentrUserInfo.sex;
                 this.userInfo.birth = currentrUserInfo.birth;
                 this.userInfo.identityNum = currentrUserInfo.identityNum;
                 this.userInfo.faviconFileDto.fileName = currentrUserInfo.logoFileName;
                 this.userInfo.faviconFileDto.fileUrl = currentrUserInfo.logoFileUrl;
                 this.userInfo.companyName = currentrUserInfo.companyName;
                 this.userInfo.email = currentrUserInfo.email;
                //  alert(currentrUserInfo.email);
                //  console.log(this.userInfo);
                 this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
                 this.updateForm.trueName = currentrUserInfo.trueName;
                 this.updateForm.mobile = currentrUserInfo.mobile;
                 this.updateForm.tel = currentrUserInfo.tel;
                 this.updateForm.fax = currentrUserInfo.fax;
                 this.updateForm.birth = this.transferDate(currentrUserInfo.birth);
                 this.updateForm.identityNum = currentrUserInfo.identityNum;
                 this.updateForm.complaintsAttachmentKey = currentrUserInfo.logoFileKey;
                 this.updateForm.complaintsAttachmentName = currentrUserInfo.logoFileName;
                 this.userInfo.sex = currentrUserInfo.sex;
              }else{
                this.$message({
                     message: "保存失败!",
                     type: 'error'
                });
              }
            }).catch((err) => {
                console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      submitPassword(){
        this.$refs['passwordForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/user/changePassword',
            {
              userId:this.userInfo.id,
              oldPassword:this.operateForm.currentPasssword,
              newPassword:this.operateForm.newPasssword
            }).then((res) => {
              this.data = res.data;
              let changeFlag = this.data.data;
              if(changeFlag){
                this.$message({
                  message: '修改密码成功',
                  type: 'success'
                });
                this.$router.push({path:"/"});
              }else{
                this.$message({
                  message: '当前密码输入错误，请重新输入',
                  type: 'error'
                });
                return false;
              }
            }).catch((err) => {
            console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      tirggerFile(event) {
        let file = event.target.files[0];
		    let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.gif|.bmp|.png|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、GIF、PNG、JPEG、BMP格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >2){
          this.$message({
                message: "上传的文件必须小于2M",
                type: 'error'
          });
          return false;
        }
        this.updateForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.updateForm.complaintsAttachmentKey = this.data.fileKey;
          this.updateForm.complaintsAttachmentName = this.data.fileName;
          this.updateForm.fileUrl = this.data.fileUrl;
          this.showFlag = true;
        }).catch((err) => {
          console.log(err)
        })
      },
//      手机号校验
      validMobile(){
        let reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(this.updateForm.mobile)&&this.updateForm.mobile!=''&&!this.overseasMobile) {
          this.invalidText = "请输入11位有效手机号码"
          this.invalidMobile = true;
        }else if(this.updateForm.mobile!=''&&this.overseasMobile&&this.updateForm.mobile.length>20){
          this.invalidText = "境外手机号码长度不能超过20位"
          this.invalidMobile = true;
        }else{
          this.invalidMobile = false;
        }
      },
      isOverseasShow(){
        this.isOverseas = true;
      },
      orderFn(){
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findPaltformMapInfo',{
        }).then((res) => {
          this.orderLink = res.data.creditOrderUrl;
        })
      },
      linkUrl () {
        if(this.getToken('isLogin') == ''){
          this.$router.push({path:'/login',query:{redirectURL:'/personalCenter'}});
        }else{
          window.location.href = this.orderLink;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/personalCenter/index.vue